import { render, staticRenderFns } from "./SearchStrategy.vue?vue&type=template&id=35ab333c&scoped=true"
import script from "./SearchStrategy.vue?vue&type=script&lang=js"
export * from "./SearchStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab333c",
  null
  
)

export default component.exports